<template>
  <div class="row">
    <div class="col-12">
      <card :title="table1.title" :subTitle="table1.subTitle">
        <br />
        <div slot="raw-content" class="table-responsive">
          <shelved-table :data="table1.data" :columns="table1.columns">
          </shelved-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus";
import { ShelvedTable } from "@/components";
const tableColumns = ["ARTWORK_PATH", "REFERENCE_ID", "PRODUCT_NAME", "SKUs", "QTY", "ITEM QTY", "TOTAL QTY", "ITEM TOTAL", "BINS", "SHIPREADY", "ACTION"];

export default {
  components: {
    ShelvedTable,
  },
  data() {
    return {
      table1: {
        title: "Shelved Items",
        columns: [...tableColumns],
        data: [],
      },
    };
  },
  mounted: function (event) {
    const self = this;
    const addToListHandler = function (order) {
      //console.log("orderinside list: " + JSON.stringify(order));
      self.table1.data.push(order.items);
    };
    EventBus.$on("shelving", addToListHandler);
  },
};
</script>